/**
 * Canonical Google Play listing, in a plain module so server and client
 * components can both import it (same reason as utils/appStore.ts).
 */
export const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.microplastics.appv1'

/** Play Console groups store-listing visits by utm_source / utm_campaign. */
function sanitizeCampaign(source: string): string {
  return source.replace(/[^a-zA-Z0-9_-]/g, '_').slice(0, 40)
}

/** Final Google Play href for a CTA, tagged with the CTA's source label. */
export function googlePlayHref(source: string): string {
  return `${GOOGLE_PLAY_URL}&utm_source=microplasticsapp&utm_medium=website&utm_campaign=${sanitizeCampaign(source)}`
}
